import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';
import { PAYMENTS_LOCAL_API_REQUESTS } from './utils/constants';

/**
 * Starts a payment. The body is empty on purpose: the amount and creditor come
 * from the invoice on the server, the return URLs are built there, and the bank
 * is chosen on the provider's hosted page after the redirect.
 */
export const initiateInvoicePayment = async (
  projectId,
  invoiceId,
  activeEmployerInfo = {}
) => {
  const apiPath = `invoice/${projectId}/${invoiceId}/payment`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: {},
    activeEmployerInfo,
    isLocalApiRequest: PAYMENTS_LOCAL_API_REQUESTS,
  });

  const response = await axios(signedRequest);

  return response.data; // { paymentId, redirectUrl, status }
};
